import React, { useEffect } from "react";
import { useRazorpay } from "react-razorpay";

const PaymentComponent = ({ onSuccess, onFailure, onCancel, data, mode }) => {
  const { Razorpay } = useRazorpay();

  useEffect(() => {
    handlePayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePayment = () => {
    const razorpayKey = process.env.REACT_APP_RAZORPAY_LIVE_KEY; 
    console.log("Razorpay key:", razorpayKey);
    if (!razorpayKey) {
      console.error("Razorpay key is not defined");
      onFailure();
      return;
    }

    const options = {
      key: razorpayKey,
      amount: data?.grand_amount, // Amount in paise
      currency: "INR",
      name: "Test Company",
      description: "Test Transaction",
      order_id: data?.order_no,
      handler: (response) => {
        onSuccess(response.razorpay_payment_id);
      },
      prefill: {
        name: "John Doe",
        email: "john.doe@example.com",
        contact: "9999999999",
      },
      theme: {
        color: "#F37254",
      },
      modal: {
        escape: true,
        ondismiss: () => {
          console.log("Razorpay modal closed");
          onCancel();
        },
      },
    };

    const razorpayInstance = new Razorpay(options);

    try {
      razorpayInstance.open();
    } catch (error) {
      console.error("Razorpay instance error:", error);
      onCancel();
    }

    razorpayInstance.on("payment.failed", (response) => {
      console.error("Payment failed:", response.error);
      onFailure();
    });
  };

  return <div></div>;
};

export default PaymentComponent;
